import { messagesTypes } from '../constants/messagesConstants';

const sendMessage = (from, to, message, userName, userEmail) => ({
    type: messagesTypes.SEND_MESSAGE,
    from,
    to,
    message,
    userName, 
    userEmail
});

const receveMessage = (from, to, message, userName, userEmail) => ({
    type: messagesTypes.RECEIVE_MESSAGE,
    from,
    to,
    message,
    userName, 
    userEmail
});

const updateMessage = (id, message) => ({
    type: messagesTypes.UPDATE_MESSAGE,
    id,
    message
});

const loadMessages = (from, messages) => ({
    type: messagesTypes.LOAD_MESSAGES,
    from,
    messages,
});

const loadFriends = (friends) => ({
    type: messagesTypes.LOAD_FRIENDS,
    friends
});

const clearUnreadMessages = (from) => ({
    type: messagesTypes.CLEAR_UNREAD_MESSAGES,
    from
});

export default {
    sendMessage,
    receveMessage,
    updateMessage,
    loadMessages,
    clearUnreadMessages,
    loadFriends
};